import { useMemo } from "react";

import { useWindowSize } from "@shared/hooks/useWindowSize";

// Common breakpoint for mobile devices (tablets and phones)
const MOBILE_BREAKPOINT = 1000;

export interface DeviceType {
  isMobile: boolean;
  isDesktop: boolean;
}

export function useDeviceType(): DeviceType {
  const { width } = useWindowSize();
  const deviceType = useMemo(
    () => ({
      isMobile: width <= MOBILE_BREAKPOINT,
      isDesktop: width > MOBILE_BREAKPOINT
    }),
    [width]
  );

  return deviceType;
}
